var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 14.6666V7.33325M1.33301 8.66659V13.3333C1.33301 14.0696 1.92996 14.6666 2.66634 14.6666H11.6172C12.6043 14.6666 13.4438 13.9464 13.5939 12.9707L14.3119 8.30403C14.4982 7.09252 13.5609 5.99992 12.3351 5.99992H9.99967C9.63148 5.99992 9.33301 5.70144 9.33301 5.33325V2.97714C9.33301 2.06925 8.59701 1.33325 7.68912 1.33325C7.47257 1.33325 7.27633 1.46078 7.18838 1.65867L4.8423 6.93734C4.7353 7.1781 4.49655 7.33325 4.23309 7.33325H2.66634C1.92996 7.33325 1.33301 7.93021 1.33301 8.66659Z",
    stroke: "#10B981",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check_success.ec70ae236e2d66d1fe4d32e604fe12c8.svg";
export { ForwardRef as ReactComponent };